import { useQuery } from '@tanstack/react-query'
import { billingApi } from '@/api/billing'
import { formatNIS } from '@/utils/currency'
import { Loading } from '@/components/ui'

interface Props {
  orgId: string
}

export default function DevicesBlock({ orgId }: Props) {
  const { data: devices, isLoading } = useQuery({
    queryKey: ['admin-billing-devices', orgId],
    queryFn: () => billingApi.listHubDevicesForOrg(orgId),
    staleTime: 60_000,
  })

  return (
    <div className="card p-6 border border-navy-border bg-[#1a1d27]">
      <h3 className="text-sm font-semibold text-ink-primary mb-4">Devices</h3>
      {isLoading ? (
        <Loading text="Loading devices…" />
      ) : !devices?.length ? (
        <p className="text-sm text-ink-secondary">No Hub devices registered for this org.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-ink-muted border-b border-navy-border">
                <th className="pb-2 pr-4 font-medium">Label</th>
                <th className="pb-2 pr-4 font-medium">Provider</th>
                <th className="pb-2 pr-4 font-medium">Billing</th>
                <th className="pb-2 text-right font-medium">Price / mo</th>
              </tr>
            </thead>
            <tbody>
              {devices.map((d) => (
                <tr key={d.id} className="border-b border-navy-border/60 last:border-0">
                  <td className="py-2 pr-4 text-ink-primary">{d.label?.trim() || '—'}</td>
                  <td className="py-2 pr-4 text-ink-secondary capitalize">{d.provider ?? '—'}</td>
                  <td className="py-2 pr-4">
                    <span className="rounded bg-navy-hover px-2 py-0.5 text-xs text-ink-secondary">
                      {d.billing_status}
                    </span>
                  </td>
                  <td className="py-2 text-right num text-ink-primary">{formatNIS(d.price_agorot ?? 0)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
